import LaunchGameStep from '../launch_gamestep_base';

export default class OpenInGameWindowGameStep extends LaunchGameStep {
    static CLASS = 'OpenInGameWindowGameStep';

    init(params) {
        super.init(params);
    }

    run(gameOptions) {
        return gameOptions.company.getGamePostMessageListener(gameOptions).then(listener => {
           gameOptions.gamePostMessageListener = listener;

            gameOptions.gameWindow.show();

            gameOptions.startLoadingTime = new Date();
            return gameOptions;
        });
    }
}